<div class="content">
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Occasion Templates</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item">Notification Campaigns</li>
          <li class="breadcrumb-item active" aria-current="page">Occasion Templates</li>
        </ol>
      </nav>
    </div>
    <div class="ms-2">
      <button class="btn btn-primary d-flex align-items-center" (click)="openModal()">
        <i class="ti ti-circle-plus me-2"></i>New Default Template
      </button>
    </div>
  </div>

  <p class="alert alert-info" *ngIf="testRunMessage">{{ testRunMessage }}</p>

  <div class="row">
    <div class="card">
      <div class="card-header"><h5>Templates</h5></div>
      <div class="card-body p-0">
        <div class="custom-datatable-filter table-responsive">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Occasion</th>
                <th>Title</th>
                <th>Scope</th>
                <th>Channel</th>
                <!-- <th>Schedule (Cron)</th>
                <th>Timezone</th> -->
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of templates">
                <td>{{ occasionLabel(t.occasion) }}</td>
                <td>{{ t.title }}</td>
                <td>
                  <span class="badge" [ngClass]="t.businessId ? 'bg-info' : 'bg-primary'">
                    {{ scopeLabel(t) }}
                  </span>
                </td>
                <td>{{ channelLabel(t.channel) }}</td>
                <!-- <td>
                  <code>{{ t.cronExpression }}</code>
                </td>
                <td>{{ t.timezone }}</td> -->
                <td class="actions-cell">
                  <!-- <button class="btn btn-secondary me-2" (click)="testRun(t)">Test Run</button> -->
                  <button class="btn btn-danger" (click)="deactivate(t)">Deactivate</button>
                </td>
              </tr>
              <tr *ngIf="!loading && templates.length === 0">
                <td colspan="7" class="empty-row">No templates found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Create Default Template Modal -->
  <!-- Create Default Template Modal -->
  <div
    class="modal-overlay"
    *ngIf="showModal"
    role="button"
    tabindex="0"
    aria-label="Close"
    (click)="closeModal()"
    (keydown.escape)="closeModal()"
  >
    <div
      class="modal"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <h3>New Default Occasion Template</h3>

      <label>Occasion</label>
      <select class="form-select" [(ngModel)]="form.occasion">
        <option value="" disabled>Select occasion type</option>
        <option *ngFor="let o of occasionOptions" [value]="o.value">{{ o.label }}</option>
      </select>

      <label class="mt-3">
        Business
        <small class="text-muted"
          >(optional — leave blank for default, applies to all businesses)</small
        >
      </label>
      <ng-select
        [items]="businesses$ | async"
        bindLabel="businessName"
        bindValue="id"
        placeholder="Select a business (leave blank for default template)"
        [searchable]="true"
        [clearable]="true"
        [searchFn]="customBusinessSearchFn"
        [(ngModel)]="form.businessId"
      >
        <ng-template ng-label-tmp let-item="item">{{ item.businessName | capitalize }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{
          item.businessName | capitalize
        }}</ng-template>
      </ng-select>

      <div class="send-row mt-3">
        <label class="mt-3">Channel</label>

        <label class="send-radio">
          <input type="radio" name="channelMode" value="push" [(ngModel)]="form.channel" />
          <span>Push Notification</span>
        </label>

        <label class="send-radio">
          <input type="radio" name="channelMode" value="email" [(ngModel)]="form.channel" />
          <span>Email</span>
        </label>
      </div>

      <label class="mt-3">
        Title
        <span *ngIf="isPushSelected" class="char-counter" [class.over-limit]="isTitleOverLimit">
          ({{ titleCharCount }}/{{ PUSH_TITLE_MAX_LENGTH }})
        </span>
      </label>
      <input
        type="text"
        class="form-control"
        [class.is-invalid]="isTitleOverLimit"
        [(ngModel)]="form.title"
        placeholder="e.g. Happy Birthday! 🎉"
      />
      <small class="text-danger" *ngIf="isTitleOverLimit">
        Title is too long for push notifications (max {{ PUSH_TITLE_MAX_LENGTH }} characters).
      </small>

      <label class="mt-3">
        Message
        <span *ngIf="isPushSelected" class="char-counter" [class.over-limit]="isMessageOverLimit">
          ({{ messageCharCount }}/{{ PUSH_MESSAGE_MAX_LENGTH }})
        </span>
      </label>
      <ckeditor
        [editor]="Editor"
        [config]="editorConfig"
        [(ngModel)]="form.message"
        (ready)="onEditorReady($event)"
        class="notification-editor"
        [class.is-invalid]="isMessageOverLimit"
      ></ckeditor>
      <small class="text-danger" *ngIf="isMessageOverLimit">
        Message is too long for push notifications (max {{ PUSH_MESSAGE_MAX_LENGTH }} characters).
        Consider Email-only for longer messages.
      </small>

      <!-- ✅ Placeholder chips -->
      <div class="d-flex flex-wrap gap-2 mt-2">
        <small class="text-muted w-100 mb-1">Click to insert:</small>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          *ngFor="let p of availablePlaceholders"
          (click)="insertPlaceholder(p.key)"
        >
          {{ p.label }}
        </button>
      </div>

      <!-- ✅ Live preview -->
      <div class="preview-box mt-3" *ngIf="form.message">
        <label class="text-muted">Preview (sample data)</label>
        <div class="preview-content">
          <strong>{{ titlePreview }}</strong>
          <div [innerHTML]="messagePreview"></div>
        </div>
      </div>

      <!-- ✅ Channel checkboxes -->
      <!-- <label class="mt-3">Channel</label>
      <div class="channel-options">
        <label class="channel-checkbox">
          <input
            type="checkbox"
            [checked]="isChannelSelected('push')"
            (change)="onChannelChange('push', $event)"
          />
          <span>Push</span>
        </label>
        <label class="channel-checkbox">
          <input
            type="checkbox"
            [checked]="isChannelSelected('email')"
            (change)="onChannelChange('email', $event)"
          />
          <span>Email</span>
        </label> -->
      <!-- <label class="channel-checkbox">
          <input
            type="checkbox"
            [checked]="form.channel === 'both'"
            (change)="onChannelChange('both', $event)"
          />
          <span>Both</span>
        </label> -->
      <!-- </div> -->

      <!-- <label class="mt-3">Check Schedule</label>
      <div class="mode-toggle">
        <button
          type="button"
          [class.active]="form.scheduleType === 'daily'"
          (click)="form.scheduleType = 'daily'"
        >
          Daily at Time
        </button>
        <button
          type="button"
          [class.active]="form.scheduleType === 'custom'"
          (click)="form.scheduleType = 'custom'"
        >
          Custom Cron
        </button>
      </div>

      <ng-container *ngIf="form.scheduleType === 'daily'">
        <label class="mt-3">Run Time</label>
        <input type="time" class="form-control" [(ngModel)]="form.runTime" />
      </ng-container>

      <ng-container *ngIf="form.scheduleType === 'custom'">
        <label class="mt-3">Cron Expression</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="form.cronExpression"
          placeholder="e.g. 0 2 * * *"
        />
        <small class="text-muted">Standard 5-field cron format</small>
      </ng-container>

      <label class="mt-3">Timezone</label>
      <select class="form-select" [(ngModel)]="form.timezone">
        <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
      </select> -->

      <p class="error-text" *ngIf="error">{{ error }}</p>

      <div class="modal-actions">
        <button class="btn btn-light" (click)="closeModal()">Cancel</button>
        <button class="btn btn-primary" (click)="save()" [disabled]="submitting">
          {{ submitting ? 'Saving...' : 'Save Template' }}
        </button>
      </div>
    </div>
  </div>
</div>
